import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

export interface PaymentPortalConfirmationData {
  confirmationNumber?: string;
  amount?: number;
  paymentDate: Date;
}

@Component({
  selector: 'ld-payment-portal-confirmation-modal',
  imports: [BaseModalComponent, MatIconModule, CurrencyPipe, DatePipe, TranslocoDirective],
  templateUrl: './payment-portal-confirmation-modal.component.html',
  styleUrl: './payment-portal-confirmation-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentPortalConfirmationModalComponent {
  readonly data = input.required<PaymentPortalConfirmationData>();
  readonly close = output<void>();

  protected onClose(): void {
    this.close.emit();
  }
}
